$ = require 'jquery'
h = require './helpers'

class PasswordRecovery
  applyStyles: ->
    console.log 'Применяю стили PasswordRecovery'
    $form = $('#aspnetForm')

#    $form.find('table').show()
    $staff = $form.children()

    h.h1('Восстановление пароля', 'h1-personal-page').appendTo $form
    [$row, $wrapper] = h.rowN(true, 'tourist-questionnaires-content')
    $form.append $row

    $('#ctl00_generalContent_LbTitle1').text('Восстановить по логину')
    $('#ctl00_generalContent_LbTitle3').html('Восстановить логин и пароль<br> по e-mail')

    $staff.appendTo $wrapper

    $('#ctl00_generalContent_btnSendPassword').appendTo $wrapper


module.exports = new PasswordRecovery()